import { createClient } from '@supabase/supabase-js'
export const sbClient = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_KEY)

class SupabaseClient{
    
    constructor() {
        if (SupabaseClient.instance) {
            return SupabaseClient.instance
        }
        this._client = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_KEY)
        SupabaseClient.instance = this
    }

    getClient() {
        return this._client
    }
}

export default SupabaseClient